import { Grid } from "@mui/material";
import ListaMenu from "./Componentes/SubComponentes/ListaMenu";
import { Helmet } from "react-helmet";

const Seccion_Comidas = () => {
    return (
        <>
            <Helmet>
                <title>Comidas | Toppings</title>
                <meta
                    name="description"
                    content="Disfruta de las mejores comidas en Colón. Explora nuestro menú variado de comida rápida y deliciosa en Toppings."
                />
                <meta
                    name="keywords"
                    content="restaurante Colón, mejor restaurante en Colón, comida rápida en Colón, menú de comida rápida en Colón, restaurante cerca de mí, comidas en Colón, toppings en Colón, comida para llevar Colón"
                />
                <meta name="robots" content="index, follow" />

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Restaurant",
                        name: "Toppings",
                        image: "https://toppings-colon.web.app/toppings.png",
                        url: "https://toppings-colon.web.app/",
                        telephone: "+57 3132391633",
                        address: {
                            "@type": "PostalAddress",
                            addressLocality: "Colón",
                            addressRegion: "Nariño",
                            addressCountry: "CO"
                        },
                        servesCuisine: ["Comida rápida", "Helados", "Bebidas"],
                        priceRange: "$"
                    })}
                </script>
            </Helmet>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{ xs: 12, sm: 12, md: 12 }}
            >
                <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                    <ListaMenu />
                </Grid>
            </Grid>
        </>
    )
}

export default Seccion_Comidas;
